// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"c27e6a92","168":"12b11f47","291":"2b33aee0","613":"004f225f","641":"c2f058ec","964":"5229fc8b"}[chunkId] + ".chunk.js";
};